import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./StageComponent.module.scss";
import { WorkflowType } from "../../models/workflow.model";

interface Props {
  workflowType: WorkflowType;
  stageCode: string;
  stageStep: Number;
  isCompleted: boolean | null;
  waitingApproval: boolean;
}

const StageComponent: React.FC<Props> = ({
  workflowType,
  stageCode,
  stageStep,
  isCompleted,
  waitingApproval,
}) => {
  const { t } = useTranslation();

  const totalSteps = workflowType === "Delete" ? 2 : 6;

  const getText = (
    stageCode: string,
    stageStep: Number,
    isCompleted: boolean | null,
    waitingApproval: boolean
  ) => {
    if (stageCode === "metadata" && isCompleted && waitingApproval) {
      return t("waitingForDoi");
    } else {
      return waitingApproval
        ? t("waitingFeedback")
        : t("stepText", { stageStep: stageStep, total: totalSteps });
    }
  };

  const text = waitingApproval
    ? t("waitingFeedback")
    : t("stepText", { stageStep: stageStep });

  return (
    <>
      <Tooltip title={t("stepCodes." + stageCode)}>
        <div
          className={
            styles.base +
            " " +
            (waitingApproval
              ? styles.waiting
              : styles["step" + (stageStep ?? 0)])
          }
        >
          <div>
            {getText(stageCode, stageStep, isCompleted, waitingApproval)}
          </div>
        </div>
      </Tooltip>
    </>
  );
};

export default StageComponent;
